import { TFunction } from 'i18next';

/**
 * Enova's "oppvarmingskarakter" is a colour grade (e.g. "green", "red") returned in English.
 * This maps the raw value to a localized label via the `building.heatingGradeValues.*` keys,
 * falling back to the raw value when the colour is not recognised.
 */
export function formatHeatingGrade(
  value: string | null | undefined,
  tGlobal: TFunction,
): string | undefined {
  if (!value) return undefined;
  const key = value.trim().toLowerCase().replace(/\s+/g, '');
  return tGlobal(`building.heatingGradeValues.${key}`, { defaultValue: value }) as string;
}
